// extracted by mini-css-extract-plugin
export default {"profile__filter":"FilterIcon_profile__filter__mImpV"};